// extracted by mini-css-extract-plugin
export var banner = "previewBanner-module--banner--0b9c9";
export var noScroll = "previewBanner-module--no-scroll--cd584";
export var text = "previewBanner-module--text--ffe10";